import { IDebounce } from "./types";
import _ from "lodash";

export const debounce: IDebounce = _.debounce;
